export default "__VITE_ASSET__02ccd4d6__"